import React, { FC } from 'react';

import { PageTitle, PageWrapper } from '../../../components';

export const EditOrganizationGroup:FC = () => (
  <PageWrapper>
    <PageTitle title="Edit group" />
  </PageWrapper>
);
